import { styled } from "@mui/material";
import { calendarDayName } from "../classes.js";
const Separator = styled("span", {
  name: calendarDayName,
  slot: "Separator",
  overridesResolver: (_, styles) => [styles.separator]
})(({ theme }) => ({
  width: 1,
  height: "75%",
  top: "50%",
  left: 3,
  position: "absolute",
  transform: "translate(0, -50%)",
  backgroundColor: (theme.vars ?? theme).palette.divider
}));
export {
  Separator
};
//# sourceMappingURL=Separator.js.map
